var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"11","viewBox":"0 0 8 11","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.31066 10.5178L0.896446 9.10355L4.68934 5.31065L0.896446 1.51776L2.31066 0.103548L7.51777 5.31065L2.31066 10.5178Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }